import { PropsWithChildren, useEffect, useMemo, useState } from 'react';
import { InboxesContext, InboxesContextType } from './index';
import { useAppContext } from 'src/contexts/AppContext';
import { InboxItem, useInboxesQuery } from 'src/api/inboxes';

export function InboxesContextProvider(props: PropsWithChildren) {
  const { currentCustomer } = useAppContext();
  const [items, setItems] = useState<InboxItem[]>([]);

  const {
    data: initialItems,
    isLoading,
    isError,
  } = useInboxesQuery(currentCustomer?.customerName ?? 'missing_customer');

  useEffect(() => {
    setItems(initialItems ?? []);
  }, [initialItems]);

  const value = useMemo<InboxesContextType>(() => {
    return {
      items,
      isLoading,
      isError,
      setItems,
    };
  }, [items, isLoading, isError]);
  return (
    <InboxesContext.Provider value={value}>
      {props.children}
    </InboxesContext.Provider>
  );
}
